"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
function InsightsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="83908" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i}>
            <Card className="h-[400px] animate-pulse border-white/5 bg-card/50">
              <div className="h-48 w-full bg-muted/30" />
              <CardHeader className="space-y-4">
                <div className="h-6 w-3/4 rounded-md bg-muted/30" />
                <div className="h-4 w-1/2 rounded-md bg-muted/30" />
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <div className="h-4 w-full rounded-md bg-muted/30" />
                  <div className="h-4 w-4/5 rounded-md bg-muted/30" />
                </div>
              </CardContent>
            </Card>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-destructive font-default">Failed to load intelligence data.</p>
        <Button variant="outline" className="border-secondary text-secondary hover:bg-secondary hover:text-white" onClick={() => window.location.reload()}>
          Try Again
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground font-sans">No strategic insights published yet. Check back soon.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="h-full">
          <Link to={post.link || "#"} className="group block h-full">
            <Card className="flex h-full flex-col overflow-hidden border-white/10 bg-card/80 transition-all duration-300 hover:border-secondary/50 hover:bg-card/90 shadow-xl">
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-muted/20">
                    <span className="text-sm text-muted-foreground font-sans">Image Pending</span>
                  </div>}
                
                {}
                <div className="absolute inset-0 bg-secondary/10 mix-blend-overlay transition-opacity duration-300 group-hover:bg-secondary/20" />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/10 to-transparent opacity-90" />

                <Badge variant="secondary" className="absolute right-4 top-4 border-none bg-secondary text-white font-sans text-xs font-bold uppercase tracking-wider shadow-lg">
                  AI Insight
                </Badge>
              </div>
              
              <CardHeader className="flex-none pb-4 pt-6">
                <CardTitle className="font-default text-xl font-bold leading-tight text-white transition-colors group-hover:text-primary">
                  {post.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="flex flex-1 flex-col justify-between">
                <div className="line-clamp-3 text-sm text-muted-foreground font-sans leading-relaxed" dangerouslySetInnerHTML={{
              __html: post.excerpt || ""
            }} />
                <div className="mt-6 flex items-center text-sm font-bold uppercase tracking-widest text-secondary transition-all duration-300 group-hover:translate-x-1">
                  Read Article
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>)}
    </div>;
}
export default function AutomationInsights() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="strategic-insights" className="dark bg-background text-foreground py-24 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 flex flex-col items-center justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
              Strategic Intelligence
            </h2>
            <p className="mt-4 text-lg text-muted-foreground font-sans max-w-xl">
              Explore high-performance strategies and technical blueprints designed to scale your real estate enterprise with AI-driven systems.
            </p>
          </div>
          <Link to="#">
            <Button variant="outline" className="hidden border-primary text-primary hover:bg-primary hover:text-background font-sans font-bold uppercase tracking-widest md:flex">
              View Intelligence Hub
            </Button>
          </Link>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <InsightsGrid />
        </PostsProvider>

        <div className="mt-10 flex justify-center md:hidden">
          <Link to="#" className="w-full">
            <Button variant="outline" className="w-full border-primary text-primary hover:bg-primary hover:text-background font-sans font-bold uppercase tracking-widest">
              View Intelligence Hub
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}